/**
 * @fileoverview gRPC-Web generated client stub for authz
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: authz/authz.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var authz_permissions_pb = require('../authz/permissions_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')

var authz_roles_pb = require('../authz/roles_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.authz = require('./authz_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.authz.AuthorizationClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.authz.AuthorizationPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.authz.GetPermissionsResponse>}
 */
const methodDescriptor_Authorization_GetPermissions = new grpc.web.MethodDescriptor(
  '/authz.Authorization/GetPermissions',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.authz.GetPermissionsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authz.GetPermissionsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authz.GetPermissionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authz.GetPermissionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authz.AuthorizationClient.prototype.getPermissions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authz.Authorization/GetPermissions',
      request,
      metadata || {},
      methodDescriptor_Authorization_GetPermissions,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authz.GetPermissionsResponse>}
 *     Promise that resolves to the response
 */
proto.authz.AuthorizationPromiseClient.prototype.getPermissions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authz.Authorization/GetPermissions',
      request,
      metadata || {},
      methodDescriptor_Authorization_GetPermissions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authz.GetAccessRolesRequest,
 *   !proto.authz.GetAccessRolesResponse>}
 */
const methodDescriptor_Authorization_GetAccessRoles = new grpc.web.MethodDescriptor(
  '/authz.Authorization/GetAccessRoles',
  grpc.web.MethodType.UNARY,
  proto.authz.GetAccessRolesRequest,
  proto.authz.GetAccessRolesResponse,
  /**
   * @param {!proto.authz.GetAccessRolesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authz.GetAccessRolesResponse.deserializeBinary
);


/**
 * @param {!proto.authz.GetAccessRolesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authz.GetAccessRolesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authz.GetAccessRolesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authz.AuthorizationClient.prototype.getAccessRoles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authz.Authorization/GetAccessRoles',
      request,
      metadata || {},
      methodDescriptor_Authorization_GetAccessRoles,
      callback);
};


/**
 * @param {!proto.authz.GetAccessRolesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authz.GetAccessRolesResponse>}
 *     Promise that resolves to the response
 */
proto.authz.AuthorizationPromiseClient.prototype.getAccessRoles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authz.Authorization/GetAccessRoles',
      request,
      metadata || {},
      methodDescriptor_Authorization_GetAccessRoles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authz.CreateAccessRoleRequest,
 *   !proto.authz.AccessRole>}
 */
const methodDescriptor_Authorization_CreateAccessRole = new grpc.web.MethodDescriptor(
  '/authz.Authorization/CreateAccessRole',
  grpc.web.MethodType.UNARY,
  proto.authz.CreateAccessRoleRequest,
  proto.authz.AccessRole,
  /**
   * @param {!proto.authz.CreateAccessRoleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authz.AccessRole.deserializeBinary
);


/**
 * @param {!proto.authz.CreateAccessRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authz.AccessRole)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authz.AccessRole>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authz.AuthorizationClient.prototype.createAccessRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authz.Authorization/CreateAccessRole',
      request,
      metadata || {},
      methodDescriptor_Authorization_CreateAccessRole,
      callback);
};


/**
 * @param {!proto.authz.CreateAccessRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authz.AccessRole>}
 *     Promise that resolves to the response
 */
proto.authz.AuthorizationPromiseClient.prototype.createAccessRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authz.Authorization/CreateAccessRole',
      request,
      metadata || {},
      methodDescriptor_Authorization_CreateAccessRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authz.UpdateAccessRoleRequest,
 *   !proto.authz.AccessRole>}
 */
const methodDescriptor_Authorization_UpdateAccessRole = new grpc.web.MethodDescriptor(
  '/authz.Authorization/UpdateAccessRole',
  grpc.web.MethodType.UNARY,
  proto.authz.UpdateAccessRoleRequest,
  proto.authz.AccessRole,
  /**
   * @param {!proto.authz.UpdateAccessRoleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authz.AccessRole.deserializeBinary
);


/**
 * @param {!proto.authz.UpdateAccessRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authz.AccessRole)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authz.AccessRole>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authz.AuthorizationClient.prototype.updateAccessRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authz.Authorization/UpdateAccessRole',
      request,
      metadata || {},
      methodDescriptor_Authorization_UpdateAccessRole,
      callback);
};


/**
 * @param {!proto.authz.UpdateAccessRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authz.AccessRole>}
 *     Promise that resolves to the response
 */
proto.authz.AuthorizationPromiseClient.prototype.updateAccessRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authz.Authorization/UpdateAccessRole',
      request,
      metadata || {},
      methodDescriptor_Authorization_UpdateAccessRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authz.DeleteAccessRoleRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Authorization_DeleteAccessRole = new grpc.web.MethodDescriptor(
  '/authz.Authorization/DeleteAccessRole',
  grpc.web.MethodType.UNARY,
  proto.authz.DeleteAccessRoleRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.authz.DeleteAccessRoleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.authz.DeleteAccessRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authz.AuthorizationClient.prototype.deleteAccessRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authz.Authorization/DeleteAccessRole',
      request,
      metadata || {},
      methodDescriptor_Authorization_DeleteAccessRole,
      callback);
};


/**
 * @param {!proto.authz.DeleteAccessRoleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.authz.AuthorizationPromiseClient.prototype.deleteAccessRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authz.Authorization/DeleteAccessRole',
      request,
      metadata || {},
      methodDescriptor_Authorization_DeleteAccessRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.authz.AccessRoleCatalog>}
 */
const methodDescriptor_Authorization_GetAccessRoleCatalog = new grpc.web.MethodDescriptor(
  '/authz.Authorization/GetAccessRoleCatalog',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.authz.AccessRoleCatalog,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authz.AccessRoleCatalog.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.authz.AccessRoleCatalog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authz.AccessRoleCatalog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authz.AuthorizationClient.prototype.getAccessRoleCatalog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authz.Authorization/GetAccessRoleCatalog',
      request,
      metadata || {},
      methodDescriptor_Authorization_GetAccessRoleCatalog,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authz.AccessRoleCatalog>}
 *     Promise that resolves to the response
 */
proto.authz.AuthorizationPromiseClient.prototype.getAccessRoleCatalog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authz.Authorization/GetAccessRoleCatalog',
      request,
      metadata || {},
      methodDescriptor_Authorization_GetAccessRoleCatalog);
};


module.exports = proto.authz;

